import clsx from 'clsx'
import React from 'react'
import Box from '@mui/material/Box'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import Editor from '../components/editable-html'

import useStyles from './true-or-false/styles'

export default function TrueOrFalseQuestion ({context, question, onPropertyChange, updateProperties}) {

  const {translate, quizQuestions = {}} = context
  const classes = useStyles()
  const answerValue = question.answer.value == undefined ? '' : question.answer.value
	
  function handlePremiseChanged (html, textpremise) {
    const premise = {html}
    updateProperties && updateProperties({id: question.id, premise, textpremise}, {premise: {$set: premise}, textpremise: {$set: textpremise}})
  }

  function handleAnswerChanged (e) {
    onPropertyChange('answer', {value: e.target.value == "true"})
  }
	
  return (
    <Box className={clsx(classes.root, "question", "true-or-false")}>
      <Box className={clsx(classes.premise, "premise")}>
        <Box className="label">{translate('premise')}:</Box>
        <Editor
          context={context}
          html={question.premise.html || ''}
          onChange={handlePremiseChanged}
        />
      </Box>
      <Box className={clsx(classes.answer, "answer")}>
        <Box className="label">{translate('answer')}:</Box>
        <RadioGroup className="content" value={answerValue} onChange={handleAnswerChanged}>
          <FormControlLabel value={true} control={<Radio />} label={translate('true')} />
          <FormControlLabel value={false} control={<Radio />} label={translate('false')} />
        </RadioGroup>
      </Box>
    </Box>
  )
}
